import React, { useCallback, useEffect, useState } from 'react';
import Bgimg from '../../static/authimg2.png';

import {Link} from 'react-router-dom';
import axios from 'axios';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import CreateIcon from '@material-ui/icons/Create';
import {makeStyles,createMuiTheme,ThemeProvider} from '@material-ui/core/styles';

import NavBar from '../../components/Navbar';
import Styles from './userprofile.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { listRequest, updateOneRequest } from '../../actions/requestActions';
import { CircularProgress } from '@material-ui/core';

const theme = createMuiTheme({
    palette: {
        primary: {
          main: "#4caf50",
        },
        secondary: {
          main: "#ffffff",
        },
      },
})

const useStyles = makeStyles((theme)=>({
    root:{
        flexGrow:1
    },
    butdiv:{
        flexGrow:1,
    },
    menuButton:{
        marginRight:theme.spacing(2),
    },
    title:{
        fontWeight:"700",
        marginRight:theme.spacing(2)
        
    },
    avatar:{
        height:theme.spacing(20),
        width:theme.spacing(20),
        background:"#f1f1f1"
    },
    butarea:{
        background:"rgba(255,255,255,.4)",
        padding:"1em",
        borderRadius:"1em",
        margin:"1em 0",
        width:"100%",
        boxShadow:"0px 4px 35px 1px rgba(50,50,50,.3)",
        letterSpacing:"3px"
    },
    profnav:{
      borderBottom:"1px solid #fff",
      flex:"1 1 auto",
      padding:"1em 1em",
      cursor:"pointer",
      fontSize:"1em",
      textAlign:"center"
  },
  active:{
      borderBottom:"3px solid #fff",
      flex:"1 1 auto",
      padding:"1em 1em",
      fontWeight:"600",
      background:"#fff",
      color:"#000",
      borderTopRightRadius:"1em",
      borderTopLeftRadius:"1em",
      color:"#1E6F11",
      textAlign:"center"
  }
}));


export default function ExpertProfile() {
    const [data1,setData] = useState([]);
    const [areq,setAreq] = useState(false);
    const [req,setReq] = useState(true);
    const classes  = useStyles();
    const dispatch = useDispatch();
    const expertSignin = useSelector(state=>state.expertSignin);
    const {loading3,expertInfo,error3} = expertSignin;

   
   const handleAccept = (requestId,status) =>{
       dispatch(updateOneRequest(requestId,status));
       console.log(requestId,status)
   } 

   const fetchMyAPI = useCallback(async () => {
    const { data } = await axios.get("https://dr-crop-backend.azurewebsites.net/api/request/getrequest", {
      headers: {
        Authorization: "Bearer " + expertInfo.token,
      },
    });
    console.log(data);
    if (data) {
      setData(data);
    }
  }, [data1]);


  const handleAreq = () =>{
    setAreq(true);
    setReq(false);
}
const handleReq = () =>{
    setAreq(false);
    setReq(true);
}
  useEffect(() => {
    fetchMyAPI();
  }, []);


    return(
        <div>
            <ThemeProvider theme={theme}>
            <NavBar />
            <img src={Bgimg} style={{position:"fixed",left:"-27em",bottom:"-8em",zIndex:"-100"}}></img>
                <Grid item container alignItems="center" justify="center" direction="column" className={Styles.avatar}>
                <Badge
                   overlap="circle"
                   anchorOrigin={{
                     vertical: 'bottom',
                     horizontal: 'right',
                   }}
                   badgeContent={<IconButton style={{background:"#4caf50"}}><CreateIcon /></IconButton>}
                   >
                     <Avatar className={classes.avatar} src="https://res.cloudinary.com/marcos-yash/image/upload/v1616877820/avatar1_kijavl_iopsya.png"></Avatar>
                     </Badge>
                <Typography align="center" style={{color:"#fff",fontSize:"1.5em",marginTop:"1em"}}>
                    @{expertInfo.name}
                </Typography>
                </Grid> 
                <Grid item container direction="row" justify="space-evenly" style={{color:"#fff",padding:"0em 1em"}}>
                    <Typography className={req?classes.active:classes.profnav} onClick={handleReq}>
                    Requests
                    </Typography >
                    
                    <Typography className={areq?classes.active:classes.profnav} onClick={handleAreq}>
                       Active Requests
                    </Typography>
                </Grid>
                {req&&<Grid container item style={{padding:"1em",color:"#fff"}} >
                    
                    {data1.length>0?data1.map((item,index)=>(<Grid key={index} item container direction="column" className={classes.butarea}>
                        <Grid>
                        <Grid item container  >
                        <Typography variant="h6">
                            {item.title} {"   "}({item.language})
                        </Typography>
                        </Grid>
                        <Typography>
                            {item.content}
                        </Typography>
                       
                        </Grid>
                        <Grid item container justify="space-between">
                          <Button variant="contained" color="secondary" style={{margin:"1em 0em"}}><Link style={{textDecoration:"none",color:"#1E6F11"}} to={`/chat?name=${expertInfo.name}&room=${item.mediumLink}`}>Get In</Link></Button>
                          <Button variant="contained" color="secondary" style={{margin:"1em 0em",color:"#1E6F11"}} onClick={()=>handleAccept(item._id,true)}>Accept</Button>
                        </Grid>
                    </Grid>)):<Grid item container justify="center" alignItems="center" style={{padding:"3em 0em"}}><CircularProgress color="secondary" size={70}></CircularProgress></Grid>}
                </Grid>}
                </ThemeProvider>
        </div>
    );
}


